export const CURRENCY_ACRONYMS = {
  AUD: 'AUD',
  USD: 'USD',
  SGD: 'SGD',
  GBP: 'GBP',
  EUR: 'EUR',
  HKD: 'HKD',
  NZD: 'NZD'
};

export const CURRENCY_SYMBOLS = {
  AUD: '$',
  USD: '$',
  SGD: '$',
  GBP: '£',
  EUR: '€',
  HKD: '$',
  NZD: '$'
};

export const CURRENCY_BY_ENTITY_CODE = {
  AUS: 'AUD',
  US: 'USD',
  ASIA_US: 'USD',
  UK: 'GBP',
  SG: 'SGD',
  EU: 'EUR',
  HK: 'HKD',
  AUS_NZD: 'NZD'
};

export const CURRENCY_MARKUP = {
  [CURRENCY_ACRONYMS.AUD]: 1.5,
  [CURRENCY_ACRONYMS.USD]: 1.5,
  [CURRENCY_ACRONYMS.SGD]: 1.5,
  [CURRENCY_ACRONYMS.GBP]: 1.5,
  [CURRENCY_ACRONYMS.EUR]: 1.5,
  [CURRENCY_ACRONYMS.HKD]: 1.5,
  [CURRENCY_ACRONYMS.NZD]: 1.5
};

export const CURRENCY_CONVERSION = {
  [CURRENCY_ACRONYMS.AUD]: 1.4,
  [CURRENCY_ACRONYMS.USD]: 1,
  [CURRENCY_ACRONYMS.SGD]: 1.4,
  [CURRENCY_ACRONYMS.GBP]: 0.8,
  [CURRENCY_ACRONYMS.EUR]: 0.9,
  [CURRENCY_ACRONYMS.HKD]: 7.75,
  [CURRENCY_ACRONYMS.NZD]: 1.3
};